import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#030308] py-16 px-4 border-t border-white/5" data-id="element-103">
      <div className="max-w-4xl mx-auto text-center" data-id="element-104">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3" data-id="element-105">
          <span className="text-4xl" data-id="element-106">🎨</span> EDULABS™ UK
        </div>

        <p className="text-white/80 text-lg leading-relaxed mb-3 max-w-xl mx-auto font-medium" data-id="element-107">
          Exceptional Resources for Grassroots Coaches.
        </p>
        <p className="text-white/70 text-sm italic mb-10" data-id="element-108">
          Because coaching shouldn't take away your moments of relaxation.
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-109" />

        <p className="text-white/60 text-xs tracking-wider" data-id="element-110">
          © EDULABS™ 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}